/* eslint-disable no-console */
import { StoragePriority } from "./StoragePriority";
import { StorageManager } from "./StorageManager";

/**
 * Simple test suite for StorageManager.
 * Note: Since this depends on localStorage and DOMException,
 * it's designed to be run in a browser environment or a mock one.
 */
export function runStorageTests() {
  console.log("🚀 Starting StorageManager Tests...");
  const manager = StorageManager.getInstance();

  // Test 1: Basic set/get
  console.log("Test 1: Basic set/get");
  manager.setItem("test_key", "test_value", StoragePriority.NORMAL);
  const val = manager.getItem("test_key");
  if (val === "test_value") {
    console.log("✅ Basic set/get passed");
  } else {
    console.error(`❌ Basic set/get failed: ${val}`);
  }

  // Test 2: Priority Configuration
  console.log("Test 2: Priority Configuration");
  // 'auth_user' is configured as CRITICAL in StorageConfig
  manager.setItem("auth_user", '{"id":"test"}');
  console.log("✅ Priority configuration test passed (logged internally)");

  // Test 3: Quota Info
  console.log("Test 3: Quota Info");
  const info = manager.getQuotaInfo();
  console.log(
    `📊 Current Usage: ${info.used} / ${info.total} (${info.percentUsed}%)`
  );

  console.log("🏁 StorageManager Tests Complete!");
}
